{
    "intro_heading": "KIES JOUW TAAL CHOISIS TA LANGUE",
    "intro_button_nl": "Nederlands",
    "intro_button_fr": "Français",

    "question_heading": "Sauras-tu deviner où cette photo a été prise ?",
    "question_cta": "Suivant",

    "outro_wrong_title": "Oops...",
    "outro_wrong_description": "Ce n’est pas la bonne réponse.",
    "outro_wrong_retry": "Rééssayer",
    "outro_wrong_showanswer": "Voir la réponse",

    "outro_answer_title": "La bonne réponse est :",
    "outro_answer_description_bxl": "L’Allemagne, au Lac d’Eibsee.",
    "outro_answer_description_ant": "L’Allemagne, au Rocher d’Eichfelsen.",
    "outro_answer_description_lie": "L’Allemagne, au Parc national de Jasmund.",
    "outro_answer_description_gnt": "L’Allemagne, au Parc national de la Suisse saxonne.",
    "outro_answer_retry": "Rééssayer",

    "outro_correct_title": "CORRECT !",
    "outro_correct_description": "Cette photo a été prise en :",
    "outro_correct_anwser_bxl": "Allemagne, au Lac D’Eibsee (Bavière, Grainau). D’ici, vous êtes à 786km de la destination.",
    "outro_correct_anwser_ant": "Allemagne, au rocher d’Eichfelsen (Baden-Wuerttemberg, Irndorf). D’ici, vous êtes à 630km de la destination.",
    "outro_correct_anwser_lie": "Allemagne, au Parc national de Jasmund (Poméranie-Occidentale-Rügen, Sassnitz). D’ici, vous êtes à 873km de la destination.",
    "outro_correct_anwser_gnt": "Allemagne, au Parc national de la Suisse saxonne (Saxe, Lohmen). D’ici, vous êtes à 832km de la destination.",
    
    "outro_correct_subtitle": "Scanne le QR code pour participer au concours et gagner un voyage en Allemagne :"
}